import type { Model } from "@foundation/hydrate-model";
import { transformUTCDate } from "~transforms/transformUTCDate";
import { issuedCurrency } from "~transforms/issuedCurrency";
import { priceMovements } from "~transforms/priceMovements";

export const tickerChart: Model = {
  id: { dataPath: "id" },
  tickerId: { dataPath: "DS001" },
  issuedCurrency: { dataPath: "", transform: issuedCurrency },
  lastUpdate: { dataPath: "UTIME", transform: transformUTCDate },
  lastUpdateUTC: { dataPath: "UTIME" },
  longName: { dataPath: "DS520" },
  marketStatus: { dataPath: "PR286" },
  name: { dataPath: "DS002" },
  previousClose: { dataPath: "PR050" },
  priceMovements: { dataPath: "", transform: priceMovements },
};
